import { createRoute } from 'framework/routing';

export const BENCH_PATH = '/bench';

export const useBenchRoute = () => {
  const routers = createRoute({ listRoute: BENCH_PATH });

  return {
    ...routers,
    copyEntityRoute: `${routers.singleEntityRoute}/copy`,
  };
};
